import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showDrugSearchModal'
            }
        ],
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            }
        ],
        searchFields: [
            {
                name: "oepNev",
                label: "Gyógyszernév",
                formType: 'text',
                formVisible: true,
                formSize: 4
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                formType: 'text',
                formVisible: true,
                formSize: 4
            },
            {
                name: "fileName",
                label: "Betöltött fájl",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllMDBFile,
                    formatText: function (val) {
                        return val.fileName;
                    },
                    formatOption: function (val) {
                        return val.fileName + ' ' + val.loaded;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'fileName',
                    returnValue: 'fileName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "archivedOnFrom",
                label: "Archiválás időponttól",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "archivedOnTo",
                label: "Archiválás időpontig",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
        ],
        headerFields: [
            {
                name: "adagEgys",
                label: "adagEgys",
                visibility: false,
            },
            {
                name: "adagMenny",
                label: "adagMenny",
                visibility: false,
            },
            {
                name: "adagmod",
                label: "adagmod",
                visibility: false,
            },
            {
                name: "besorolas",
                label: "besorolas",
                visibility: false,
            },
            {
                name: "brandId",
                label: "brandId",
                visibility: false,
            },
            {
                name: "brandnev",
                label: "brandnev",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "dddEgys",
                label: "dddEgys",
                visibility: false,
            },
            {
                name: "dddFaktor",
                label: "dddFaktor",
                visibility: false,
            },
            {
                name: "dddMenny",
                label: "dddMenny",
                visibility: false,
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "egyedi",
                label: "egyedi",
                visibility: false,
            },
            {
                name: "egyenid",
                label: "egyenid",
                visibility: false,
            },
            {
                name: "egysegar",
                label: "egysegar",
                visibility: false,
            },
            {
                name: "euemFelme",
                label: "euemFelme",
                visibility: false,
            },
            {
                name: "euemFixid",
                label: "euemFixid",
                visibility: false,
            },
            {
                name: "euemKihi",
                label: "euemKihi",
                visibility: false,
            },
            {
                name: "euemPontok",
                label: "euemPontok",
                visibility: false,
            },
            {
                name: "euemRefntk",
                label: "euemRefntk",
                visibility: false,
            },
            {
                name: "euemSzaz",
                label: "euemSzaz",
                visibility: false,
                formType: '',
            },
            {
                name: "euemTerdij",
                label: "euemTerdij",
                visibility: false,
                formType: '',
            },
            {
                name: "euemTip",
                label: "euemTip",
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemFelme",
                label: "eukiemFelme",
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemFixid",
                label: "eukiemFixid",
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemKihi",
                label: "eukiemKihi",
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemPontok",
                label: "eukiemPontok",
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemRefntk",
                label: "eukiemRefntk",
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemSzaz",
                label: "eukiemSzaz",
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemTerdij",
                label: "eukiemTerdij",
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemTip",
                label: "eukiemTip",
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgalmaz",
                label: "forgalmaz",
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgalmazId",
                label: "forgalmazId",
                visibility: false,
                formType: '',
            },
            {
                name: "forgalomban",
                label: "forgalomban",
                visibility: false,
                formType: '',
            },
            {
                name: "forgengt",
                label: "forgengt",
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgengtId",
                label: "forgengtId",
                visibility: false,
                formType: '',
            },
            {
                name: "gyforma",
                label: "gyforma",
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepNev",
                label: "Gyógyszernév",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "hatoEgys",
                label: "Egy kiszerelési egységben lévő hatóanyag egység",
                visibility: false,
                formType: 'text',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "hatoMenny",
                label: "Egy kiszerelési egységben lévő hatóanyag mennyiség",
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "id",
                label: "id",
                visibility: false,
                formType: '',
            },
            {
                name: "idGyforma",
                label: "idGyforma",
                visibility: false,
                formType: '',
            },
            {
                name: "keresztjelzes",
                label: "keresztjelzes",
                visibility: false,
                formType: 'text',
            },
            {
                name: "kestTerm",
                label: "kestTerm",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "kgykeret",
                label: "kgykeret",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "kiszEgys",
                label: "Kiszerelés egység",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "dot",
                label: "Kiszerelés hány napra elegendő",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "kiszMenny",
                label: "Kiszerelés mennyiség",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "kozhid",
                label: "kozhid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "nicheId",
                label: "nicheId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normFelme",
                label: "normFelme",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "normFixid",
                label: "normFixid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normKihi",
                label: "normKihi",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "normMihacel",
                label: "normMihacel",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normMihaid",
                label: "normMihaid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normMihastat",
                label: "normMihastat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normRefntk",
                label: "normRefntk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normSzaz",
                label: "normSzaz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normTerdij",
                label: "normTerdij",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normTip",
                label: "normTip",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "ntk",
                label: "Napi terápiás költésg",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "ntkEetd",
                label: "ntkEetd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "ntkEktd",
                label: "ntkEktd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "ntkTd",
                label: "ntkTd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepAfa",
                label: "oepAfa",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepAtc",
                label: "oepAtc",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepDat",
                label: "oepDat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepEan",
                label: "oepEan",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepEu100b",
                label: "oepEu100b",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEu100n",
                label: "oepEu100n",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEub",
                label: "oepEub",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEun",
                label: "oepEun",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepFab",
                label: "Fogyasztói ár",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "oepFan",
                label: "oepFan",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepInb",
                label: "oepInb",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepInn",
                label: "oepInn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepIso",
                label: "oepIso",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepItm",
                label: "oepItm",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc1",
                label: "oepJc1",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc2",
                label: "oepJc2",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc3",
                label: "oepJc3",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc4",
                label: "oepJc4",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc5",
                label: "oepJc5",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepKsz",
                label: "oepKsz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepNkar",
                label: "oepNkar",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepTar",
                label: "oepTar",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepTk",
                label: "oepTk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepTtt",
                label: "oepTtt",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "ohatoMenny",
                label: "ohatoMenny",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "patika",
                label: "patika",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "potencia",
                label: "potencia",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "prasTermek",
                label: "prasTermek",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "regiNev",
                label: "regiNev",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "rendelhet",
                label: "rendelhet",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "switch",
                label: "switch",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tipus",
                label: "tipus",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tktorles",
                label: "tktorles",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tktorlesdat",
                label: "tktorlesdat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "rendelhetoseg",
                label: "Készítmény rendelhetősége",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "fileName",
                label: "Betöltött fájl",
                sort: true,
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllMDBFile,
                    formatText: function (val) {
                        return val.fileName;
                    },
                    formatOption: function (val) {
                        return val.fileName + ' ' + val.loaded;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'fileName',
                    returnValue: 'fileName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "archivedOn",
                label: "Archiválás ideje",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "archivedBy",
                label: "Archiváló",
                sort: true,
                visibility: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
